import React, { useState } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { Link } from 'react-router-dom'
import Requests from '../../utils/Requests/Index'
import DeleteComponent from '../modal/delete/Index'
import {  edit2, trash } from 'react-icons-kit/feather'

const VerificationService = ({ items, refetch }) => {
    const [isDelete, setDelete] = useState({ value: null, show: false, loading: false })
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    const handleDelete = async id => {
        setDelete({ ...isDelete, loading: true })
        await Requests.VerificationService.Delete(id, header)
        refetch()
        setDelete({ value: null, status: null, loading: null })
    }

    return (
        <div className="content-image-table-container pb-4">
            <table className="table table-hover table-responsive-sm table-borderless">
                <thead>
                    <tr className="border-bottom">
                        <td className="text-center sl-td">SL</td>
                        <td>Date</td>
                        <td>NID Image</td>
                        <td>Name</td>
                        <td>Phone</td>
                        <td>Package</td>
                        <td>Verification</td>
                        <td className="text-td text-center">Action</td>
                    </tr>
                </thead>
                <tbody>
                    {items && items.length ?
                        items.map((item, i) =>
                            <tr className="border-bottom" key={i}>
                                <td className="text-center sl-td">{i + 1}</td>
                                <td className="text-td">{item.createdAt ? item.createdAt.split('T')[0] : 'N/A'}</td>
                                <td className="text-td">
                                     {item.image ? <img src={item.image} className="img-fluid" alt="..." /> : 'N/A'}
                                </td>
                                <td className="text-td">{item.name ? item.name : 'N/A'}</td>
                                <td className="text-td">{item.phone ? item.phone : 'N/A'}</td>
                                <td className="text-td">{item.package ? item.package : 'N/A'}</td>
                                <td className="text-td">{item.verificationType ? 'Verified' : 'Not Verified'}</td>

                                <td className="button-td text-center">
                                    {/* <Link
                                        type="button"
                                        to={`/dashboard/website/expert-counselors-profile/${item._id}/show`}
                                        className="btn btn-sm shadow-none table-show-btn"
                                    >
                                        <Icon icon={eye} size={20} />
                                    </Link> */}
                                    <Link
                                        type="button"
                                        to={`/dashboard/website/verification-service/${item._id}/edit`}
                                        className="btn btn-sm shadow-none table-edit-btn"
                                    >
                                        <Icon icon={edit2} size={20} />
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn btn-sm shadow-none table-trash-btn"
                                        onClick={() => setDelete({ value: item, show: true, loading: false })}
                                    >
                                        <Icon icon={trash} size={20} />
                                    </button>
                                </td>
                            </tr>
                        ) : null}
                </tbody>
            </table>

            {/* Delete modal */}
            {isDelete.value && isDelete.show ?
                <DeleteComponent
                    title={'Blog'}
                    image={isDelete.value.image}
                    data={isDelete.value._id}
                    show={isDelete.show}
                    loading={isDelete.loading}
                    delete={handleDelete}
                    onHide={() => setDelete({ ...isDelete, value: null, status: false })}
                />
                : null}

        </div>
    )
};

export default VerificationService;